import React from "react";
import { observer } from "mobx-react";
import { CollectiveManagementSocietyCreateStore } from "../../store";
import { CollectiveManagementSocietyCreateForm } from "./CollectiveManagementSocietyCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type CollectiveManagementSocietyCreateProps = {
  collectiveManagementSocietyCreateStore: CollectiveManagementSocietyCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const CollectiveManagementSocietyCreate: React.FC<CollectiveManagementSocietyCreateProps> =
  observer(
    ({
      collectiveManagementSocietyCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay
            open={collectiveManagementSocietyCreateStore.isSaving}
          />
          <CollectiveManagementSocietyCreateForm
            collectiveManagementSocietyCreateStore={
              collectiveManagementSocietyCreateStore
            }
            nameError={
              collectiveManagementSocietyCreateStore.errors.name?.message
            }
            onNameChange={(value: string) => {
              collectiveManagementSocietyCreateStore.setNameValue(value);
            }}
            name={collectiveManagementSocietyCreateStore.entityValues.name}
            acronymError={
              collectiveManagementSocietyCreateStore.errors.acronym?.message
            }
            onAcronymChange={(value: string) => {
              collectiveManagementSocietyCreateStore.setAcronymValue(value);
            }}
            acronym={
              collectiveManagementSocietyCreateStore.entityValues.acronym
            }
            countryError={
              collectiveManagementSocietyCreateStore.errors.country?.message
            }
            onCountryChange={(value) => {
              collectiveManagementSocietyCreateStore.setCountryValue(value);
            }}
            countrySelectedValue={
              collectiveManagementSocietyCreateStore.entityValues.showCountry
            }
            onCountrySelected={(value) => {
              collectiveManagementSocietyCreateStore.setSelectedCountry(value);
            }}
            countryOptions={collectiveManagementSocietyCreateStore.getCountryOptions()}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={collectiveManagementSocietyCreateStore.isProcessing}
            onSave={() =>
              collectiveManagementSocietyCreateStore.saveNewCollectiveManagementSociety()
            }
            onCancel={() =>
              collectiveManagementSocietyCreateStore.cancelNewCollectiveManagementSociety()
            }
          />
          <ErrorDialog
            open={collectiveManagementSocietyCreateStore.errorDialogOpened}
            title={collectiveManagementSocietyCreateStore.errorTitle}
            description={
              collectiveManagementSocietyCreateStore.errorDescription
            }
            onClose={() =>
              collectiveManagementSocietyCreateStore.closeErrorDialog()
            }
          />
        </>
      );
    }
  );
